// eslint-disable-next-line import/no-cycle
import { BaseFieldConfig, ComponentNameEnum } from '@/types';

const loopFieldConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.FORM_FIELD_LOOP_CONFIGURATION,
  options: {},
};

export default loopFieldConfig;
